import React from 'react';
import PropTypes from 'prop-types';

import InspirationPhotoCard from 'components/consumer/inspiration-photos-card';
import RatioContainer from 'components/consumer/RatioContainer';
import ReviewComponent from 'components/consumer/PDP/PDPFabricDetailSidebar/PDPFabricReviews/ReviewComponent';
import ProductCardStatic from 'components/consumer/ProductCardStatic';

const MixedGridCard = ({
  index,
  hits,
  hoveredValue,
  layout,
  onHoverHandler,
  toggleModalView,
  card_type,
  onClick,
  photo_id,
  customer_first_name,
  customer_last_name,
  image_link,
  photo_comment,
  products,
  date,
  full_name,
  location,
  rate,
  review,
  productData,
}) => {
  if (card_type === 'product' && productData) {
    return <ProductCardStatic {...productData} layout={layout} />;
  }
  if (card_type === 'customer_photo') {
    return (
      <RatioContainer>
        <InspirationPhotoCard
          hits={hits}
          hoveredValue={hoveredValue}
          index={index}
          onClick={onClick}
          onHoverHandler={onHoverHandler}
          photo={{
            photo_id,
            customer_first_name,
            customer_last_name,
            image_link,
            photo_comment,
            products,
          }}
          toggleModalView={toggleModalView}
        />
      </RatioContainer>
    );
  }
  if (card_type === 'review') {
    return (
      <ReviewComponent
        collapsible
        date={date}
        full_name={full_name}
        isInMixedGrid
        location={location}
        maxWords={100}
        rate={rate}
        review={review}
      />
    );
  }
  return null;
};

MixedGridCard.propTypes = {
  cardSize: PropTypes.string,
  card_type: PropTypes.string,
  currentParentColors: PropTypes.arrayOf({}),
  customer_first_name: PropTypes.string,
  customer_last_name: PropTypes.string,
  date: PropTypes.string,
  disablePDPPrefetch: PropTypes.bool,
  full_name: PropTypes.string,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image_link: PropTypes.string,
  index: PropTypes.number,
  layout: PropTypes.string,
  location: PropTypes.string,
  onClick: PropTypes.func,
  onHoverHandler: PropTypes.func,
  photo_comment: PropTypes.string,
  photo_id: PropTypes.string,
  productData: PropTypes.object,
  products: PropTypes.array,
  toggleModalView: PropTypes.func,
  rate: PropTypes.number,
  review: PropTypes.string,
};

export default MixedGridCard;
